if (!customElements.get("hulii-v2-cart")) {
  customElements.define(
    "hulii-v2-cart",
    class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const events = { signal: this.controller.signal };
        this.dialog = this.querySelector("dialog");
        if (typeof this.dialog.showModal !== "function") return;
        document.addEventListener(
          "click",
          (event) => {
            const link = event.target.closest("[data-hv2-cart-open]");
            if (
              !link ||
              event.metaKey ||
              event.ctrlKey ||
              event.shiftKey ||
              event.altKey ||
              event.button !== 0
            )
              return;
            event.preventDefault();
            this.opener = link;
            this.open();
            this.refresh();
          },
          events,
        );
        this.querySelector("[data-cart-close]").addEventListener(
          "click",
          () => this.dialog.close(),
          events,
        );
        this.dialog.addEventListener(
          "click",
          (event) => {
            if (event.target === this.dialog) this.dialog.close();
          },
          events,
        );
        this.dialog.addEventListener(
          "close",
          () => {
            if (this.opener?.isConnected) this.opener.focus();
          },
          events,
        );
        this.addEventListener(
          "change",
          (event) => {
            if (!event.target.matches("[data-line-key]")) return;
            if (!event.target.checkValidity()) {
              event.target.reportValidity();
              return;
            }
            this.change(
              event.target.dataset.lineKey,
              Number(event.target.value),
            );
          },
          events,
        );
        this.addEventListener(
          "click",
          (event) => {
            const remove = event.target.closest("[data-remove-key]");
            if (!remove) return;
            event.preventDefault();
            this.change(remove.dataset.removeKey, 0);
          },
          events,
        );
      }
      open() {
        if (!this.dialog.open) this.dialog.showModal();
      }
      status(message) {
        this.querySelector("[data-cart-status]").textContent = message;
      }
      busy(value) {
        this.pending = value;
        this.setAttribute("aria-busy", String(value));
        this.querySelectorAll(
          "[data-cart-content] input, [data-cart-content] button",
        ).forEach((input) => {
          input.disabled = value;
        });
      }
      apply(html) {
        if (!html) throw new Error("Cart section missing");
        const documentFragment = new DOMParser().parseFromString(
          html,
          "text/html",
        );
        const content = documentFragment.querySelector("[data-cart-content]");
        if (!content) throw new Error("Cart content missing");
        this.querySelector("[data-cart-content]").replaceWith(content);
        document.querySelectorAll(".hv2-cart-count").forEach((count) => {
          count.textContent = content.dataset.cartCount;
          count.hidden = Number(content.dataset.cartCount) === 0;
        });
      }
      async refresh() {
        if (this.pending) return;
        this.busy(true);
        this.status("");
        try {
          const url = new URL(this.dataset.cartUrl, location.origin);
          url.searchParams.set("sections", this.dataset.sectionId);
          const response = await fetch(url, { signal: this.controller.signal });
          if (!response.ok) throw new Error("Refresh failed");
          this.apply((await response.json())[this.dataset.sectionId]);
        } catch (error) {
          if (error.name !== "AbortError") this.status(this.dataset.error);
        } finally {
          this.busy(false);
        }
      }
      async add(form, button) {
        if (this.pending) return;
        this.busy(true);
        button.disabled = true;
        this.status("");
        this.opener = button;
        this.open();
        let accepted = false;
        try {
          const payload = new FormData(form);
          payload.set("sections", this.dataset.sectionId);
          payload.set("sections_url", location.pathname);
          const response = await fetch(form.action + ".js", {
            method: "POST",
            body: payload,
            signal: this.controller.signal,
          });
          if (!response.ok) {
            const failure = await response.json();
            this.status(
              typeof failure.description === "string"
                ? failure.description
                : this.dataset.error,
            );
            return;
          }
          accepted = true;
          const result = await response.json();
          this.apply(result.sections?.[this.dataset.sectionId]);
        } catch (error) {
          // Never automatically retry a mutation: it may already have reached Shopify.
          if (error.name !== "AbortError")
            this.status(accepted ? this.dataset.error : this.dataset.uncertain);
        } finally {
          this.busy(false);
          button.disabled = false;
        }
      }
      async change(key, quantity) {
        if (this.pending || !Number.isInteger(quantity) || quantity < 0) return;
        this.busy(true);
        this.status("");
        try {
          const response = await fetch(this.dataset.changeUrl + ".js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            signal: this.controller.signal,
            body: JSON.stringify({
              id: key,
              quantity,
              sections: [this.dataset.sectionId],
              sections_url: location.pathname,
            }),
          });
          const result = await response.json();
          if (!response.ok) {
            this.querySelectorAll("[data-line-key]").forEach((input) => {
              input.value = input.defaultValue;
            });
            this.status(
              typeof result.description === "string"
                ? result.description
                : this.dataset.error,
            );
            return;
          }
          this.apply(result.sections?.[this.dataset.sectionId]);
          this.querySelector("[data-cart-close]").focus();
        } catch (error) {
          if (error.name !== "AbortError") this.status(this.dataset.uncertain);
        } finally {
          this.busy(false);
        }
      }
      disconnectedCallback() {
        this.controller?.abort();
      }
    },
  );
}
